import React from "react";
import aboutImage from "../../assets/images/Home/aboutsection.jpg";
import { Link } from "react-router-dom";

const AboutSection = () => {
  const colors = {
    sectionBg: "#F9FBFA",
    accent: "#D7A19E",
    dark: "#546E7A",
    text: "#4A5A64",
    border: "#C5B358",
    divider: "#9BB2A3",
  };

  return (
    <section
      style={{ backgroundColor: colors.sectionBg, fontFamily: "Poppins, sans-serif" }}
      className="relative py-28 px-6 md:px-16 lg:px-32 overflow-hidden"
    >
      {/* Background Watermark */}
      <div className="absolute top-10 left-10 opacity-[0.03] pointer-events-none hidden lg:block">
        <h1 className="text-[12rem] leading-none">Care</h1>
      </div>

      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-20 relative z-10">
        
        {/* LEFT IMAGE */}
        <div className="flex-1 relative w-full group">
          <div 
            style={{ borderColor: colors.border }}
            className="absolute -top-6 -left-6 w-2/3 h-2/3 border-[1px] -z-10 transition-transform duration-700 group-hover:-translate-x-2 group-hover:-translate-y-2"
          ></div>
          
          <div className="relative overflow-hidden shadow-[20px_20px_60px_-15px_rgba(0,0,0,0.1)]">
            <img
              src={aboutImage}
              alt="Clinic Interior"
              className="w-full h-[550px] object-cover transition-transform duration-[2s] group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-black/5"></div>
          </div>

          {/* Badge */}
          <div className="absolute bottom-10 -right-4 lg:-right-10 bg-white p-8 shadow-xl border-l-4" style={{ borderColor: colors.accent }}>
            <span className="block text-3xl text-gray-900 leading-none">20+</span>
            <span className="text-[10px] uppercase tracking-[0.2em] text-gray-500 font-bold">Years of Trust</span>
          </div>
        </div>

        {/* RIGHT CONTENT */}
        <div className="flex-1 text-left">
          <header className="mb-8">
            <span 
              style={{ color: colors.accent }} 
              className="text-xs uppercase tracking-[0.4em] font-semibold block mb-4"
            >
              Excellence in Fertility
            </span>

            <h2
              style={{ color: colors.dark }}
              className="text-4xl md:text-5xl lg:text-6xl font-light leading-[1.15] mb-6"
            >
              The Science of Life, <br />
              <span style={{ color: colors.accent }} >
                Wrapped in Care.
              </span>
            </h2>

            <div
              style={{ backgroundColor: colors.divider }}
              className="w-20 h-[1px]"
            ></div>
          </header>

          {/* CONTENT */}
          <div
            style={{ color: colors.text }}
            className="space-y-6 text-lg font-light leading-relaxed text-justify"
          >
            <p>
              At <span className="font-medium text-gray-900 underline decoration-pink-100 underline-offset-4">Dr. Vibha Singh</span>, 
              we transcend the boundaries of standard medicine. We believe every 
              journey to parenthood is a sacred narrative that deserves the 
              highest caliber of clinical expertise and emotional sanctuary.
            </p>

            <p>
              "Our mission is not just to treat, but to transform lives through 
              innovation and deep-rooted compassion."
            </p>

            <p>
              Equipped with avant-garde laboratories and a hand-picked team of 
              specialists, we provide a bespoke environment where your 
              well-being is the ultimate priority.
            </p>
          </div>

          {/* BUTTON */}
          <div className="mt-12">
            <Link to="/about-us" className="group relative inline-block">
              <button
                style={{ "--bg-dark": colors.dark }}
                className="relative z-10 px-12 py-4 uppercase tracking-[0.2em] rounded-xl text-[10px] font-bold transition-all duration-500 
                bg-[var(--bg-dark)] text-white border border-transparent 
                group-hover:bg-white group-hover:text-black group-hover:border-black"
              >
                Read more 
              </button>

              <div className="absolute top-2 left-2 w-full h-full border border-black/10 -z-10 transition-transform duration-500 group-hover:translate-x-1 group-hover:translate-y-1"></div>
            </Link>
          </div>
        </div>

      </div>
    </section>
  );
};

export default AboutSection;